import { Card, Flex } from 'antd';

import CeaseAndDesist from './CeaseAndDesist';
import DeceasedStatus from './DeceasedStatus';
import IncomeResidence from './IncomeResidence';
import BankruptcyLegalInfo from './BankruptcyLegalInfo';

const CustomerDetailsPage = () => {
  return (
    <Card style={{ paddingBottom: 'var(--spacing)' }}>
      <Flex vertical={true} gap="var(--spacing-xl)">
        <IncomeResidence />
        <CeaseAndDesist />
        <DeceasedStatus />
        <BankruptcyLegalInfo />
      </Flex>
    </Card>
  );
};

export default CustomerDetailsPage;
